import { createStyles, Theme } from '@material-ui/core';

export default ({
  custom: {
    palette: { colorDarkGray, colorGrayishBlue, colorAccentSunrise, colorAccentPeach, colorMessageBubble },
  },
  palette: {
    common: { white },
    text,
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    avatarBot: {
      color: '#fff',
      backgroundColor: colorMessageBubble,
      width: 26,
      height: 26,
    },
    attachButton: {
      backgroundColor: `${white} !important`,
      height: 25,
      marginTop: 5,
      padding: `0px ${unit * 2}px`,
    },
    attachButtonLabel: {
      color: `${text.primary} !important`,
      fontSize: 11,
      textTransform: 'initial',
    },
    attachIcon: {
      fontSize: 14,
    },
    chatAudit: {},
    interlocutor: {
      color: text.secondary,
      display: 'inline-block',
      float: 'right',
      fontSize: 13,
      fontWeight: 500,
      padding: `${unit / 2}px ${unit / 4 + 4}px ${unit + 4}px 0px`,
      textAlign: 'right',
      width: '100%',
    },
    internal: {},
    messageContent: {
      color: 'inherit',
      fontWeight: 'inherit',
      width: '100%',
      wordBreak: 'break-word',
      wordWrap: 'break-word',
      '& a': {
        color: 'inherit !important',
      },
    },
    messageIcon: {
      position: 'absolute',
      width: 35,
      height: 35,
      left: -18,
      top: -18,
      border: '1px solid',
      '& span': {
        fontSize: 18,
      },
    },
    messageWrapper: {
      alignItems: 'flex-start',
      backgroundColor: colorGrayishBlue,
      position: 'relative',
      border: '1px',
      borderRadius: '15px 15px 15px 0px',
      color: text.primary,
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 500,
      marginLeft: unit / 2,
      marginRight: 0,
      maxWidth: '80%',
      padding: '10px 15px',
      '&$outbound': {
        backgroundColor: colorMessageBubble,
        borderRadius: '15px 15px 0px 15px !important',
        color: `${white} !important`,
        alignItems: 'flex-end !important',
        marginLeft: '0px !important',
        marginRight: `${unit / 2}px !important`,
      },
      '&$internal': {
        backgroundColor: `${colorAccentSunrise} !important`,
        border: `1px solid ${colorAccentPeach} !important`,
        color: `${text.primary} !important`,
      },
    },
    outbound: {},
    primary: {},
    pullBottom: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 5,
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      '&$outbound': {
        justifyContent: 'flex-end !important',
      },
      '&$chatAudit': {
        color: colorDarkGray,
        padding: unit * 2,
        fontSize: 14,
        fontWeight: 500,
        display: 'inline-block',
        textAlign: 'center',
      },
    },
    '@keyframes blink': {
      '50%': {
        transform: 'scale(1.5)',
      },
    },
  });
